<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addEventDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :rules="form_rules"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <!--需要导入日期插件-->
        <el-form-item prop="eventDate" label="日期">
          <el-date-picker
            v-model="form.eventDate"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item prop="eventContent" label="事件内容">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入事件内容"
            v-model="form.eventContent"
          ></el-input>
        </el-form-item>

        <el-form-item prop="eventType" label="事件类型">
          <el-select v-model="form.eventType" placeholder="请选择事件类型">
            <el-option
              v-for="item in eventType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="eventNote" label="事件备注">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入事件备注"
            v-model="form.eventNote"
          ></el-input>
        </el-form-item>

        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { addEvent, updateEvent } from "@/api/event";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    let validateData = (rule, value, callback) => {
      if (value === "") {
        let text;
        if (rule.field == "telephoneNumber") {
          text = "手机号";
        } else if (rule.field == "name") {
          text = "姓名";
        }
        callback(new Error(text + "不能为空~"));
      } else {
        let numReg = /^1[3456789]\d{9}$/;
        if (!numReg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      }
    };
    return {
      isVisible: this.isShow,
      form: {
        id: "",
        eventContent: "",
        eventDate: "",
        eventType: "",
        eventNote: "",
      },
      format_event_type_list: {
        0: "自编",
        1: "自动",
        2: "候补",
        3: "取消",
        4: "上课",
        5: "预约",
        6: "登记",
      },
      eventType: [
        { label: "自编", value: "0" },
        { label: "自动", value: "1" },
        { label: "候补", value: "2" },
        { label: "取消", value: "3" },
        { label: "上课", value: "4" },
        { label: "预约", value: "5" },
        { label: "登记", value: "6" },
      ],
      form_rules: {
        stdName: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        stdParentName: [
          { required: true, message: "家长不能为空", trigger: "blur" },
        ],
        stdStatus: [
          { required: true, message: "请选择学员状态", trigger: "blur" },
        ],
        stdIsPassExam: [
          { required: true, message: "请选择是否通过考核", trigger: "blur" },
        ],
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    stdName: String,
  },
  computed: {
    ...mapGetters(["addEventDialog", "eventSearch"]),
  },
  created() {},
  mounted() {
    if (this.addEventDialog.type === "edit") {
      console.log(this.dialogRow);
      this.form = this.dialogRow;
      this.form.eventType = this.dialogRow.eventType.toString();
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData, this.eventSearch);
          console.log(para);
          // edit
          if (this.addEventDialog.type === "edit") {
            let eventContent = this.dialogRow.eventContent;
            let eventType = this.format_event_type_list[
              parseInt(this.dialogRow.eventType)
            ];
            let eventDate = this.dialogRow.eventDate;
            updateEvent(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content:
                    "修改学员(" +
                    this.stdName +
                    ")事件操作,事件内容:" +
                    eventContent +
                    ",事件类型:" +
                    eventType +
                    ",事件日期:" +
                    eventDate,
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.isVisible = false;
                this.$emit("getEventList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          } else {
            // add
            addEvent(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "新增事件操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getEventList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
